var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ma-8" },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loaderOverlay
        ? _c(
            "v-card",
            {
              staticClass: "pb-10",
              attrs: {
                color: _vm.$vuetify.theme.dark ? "#2E2E2E" : "grey lighten-3",
                "min-width": "640",
              },
            },
            [
              _c(
                "v-card-title",
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mr-5",
                      attrs: { justify: "start", "no-gutters": "" },
                    },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "pr-2", attrs: { large: "" } },
                        [_vm._v("mdi-account-box-multiple-outline ")]
                      ),
                      _c("h3", [_vm._v(_vm._s(_vm.$t("eventLogs")))]),
                      _c("v-spacer"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card",
                { staticClass: "mx-10 pa-2 my-2" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pa-0 ma-0" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-row",
                        {
                          staticClass: "pr-5",
                          attrs: {
                            "fill-height": "",
                            align: "center",
                            justify: "end",
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "prepend-icon": "mdi-filter-outline",
                                color: "red white--text",
                              },
                              on: { click: _vm.handleSelectionClick },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("filterColumns")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("v-divider", {
                        staticClass: "mx-3",
                        attrs: { vertical: "" },
                      }),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c("v-select", {
                            attrs: {
                              label: _vm.$t("pageSize"),
                              items: _vm.pageSizes,
                              outlined: "",
                              "hide-details": "",
                              dense: "",
                            },
                            model: {
                              value: _vm.pageSize,
                              callback: function ($$v) {
                                _vm.pageSize = $$v
                              },
                              expression: "pageSize",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.list.length > 0
                        ? _c("v-divider", {
                            staticClass: "mx-3",
                            attrs: { vertical: "" },
                          })
                        : _vm._e(),
                      _vm.list.length > 0
                        ? _c(
                            "v-tooltip",
                            {
                              staticClass: "white-text",
                              attrs: { bottom: "", color: "primary" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: _vm.handleCSVExport,
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { large: "" } },
                                              [
                                                _vm._v(
                                                  " mdi-file-export-outline "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4159858969
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("logfileExport"))),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card",
                { staticClass: "mx-10 my-2" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pa-0 ma-0 mx-2 align-center" },
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.$t("search"),
                              clearable: "",
                              "prepend-inner-icon": "mdi-magnify",
                              "hide-details": "",
                              dense: "",
                            },
                            model: {
                              value: _vm.searchTerm,
                              callback: function ($$v) {
                                _vm.searchTerm = $$v
                              },
                              expression: "searchTerm",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mx-2",
                          staticStyle: { display: "inline-flex" },
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("mdi-calendar-arrow-left"),
                          ]),
                          _c("DatePicker", {
                            attrs: {
                              dense: "",
                              mydate1: _vm.date.from,
                              label: _vm.$t("dateFrom"),
                            },
                            model: {
                              value: _vm.date.from,
                              callback: function ($$v) {
                                _vm.$set(_vm.date, "from", $$v)
                              },
                              expression: "date.from",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mx-2",
                          staticStyle: { display: "inline-flex" },
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("mdi-calendar-arrow-right"),
                          ]),
                          _c("DatePicker", {
                            attrs: {
                              dense: "",
                              mydate1: _vm.date.until,
                              label: _vm.$t("dateUntil"),
                            },
                            model: {
                              value: _vm.date.until,
                              callback: function ($$v) {
                                _vm.$set(_vm.date, "until", $$v)
                              },
                              expression: "date.until",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "white-text",
                          attrs: { bottom: "", color: "primary" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, on),
                                      [
                                        !_vm.refetchActive
                                          ? _c(
                                              "v-btn",
                                              {
                                                staticClass: "mx-3",
                                                attrs: { color: "primary" },
                                                on: { click: _vm.refetch },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("refresh"))
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "v-btn",
                                              {
                                                staticClass: "mx-3",
                                                attrs: {
                                                  color: "primary",
                                                  icon: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "rotate" },
                                                  [_vm._v("mdi-refresh")]
                                                ),
                                              ],
                                              1
                                            ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3029937237
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.lastRefresh))])]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.list.length === 0
                ? _c(
                    "v-card",
                    { staticClass: "mx-10 my-5" },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-spacer"),
                          _c(
                            "v-col",
                            {
                              staticClass: "py-10",
                              staticStyle: {
                                "text-align": "center",
                                "font-size": "1.5rem",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("noEventLogEntries")) + " "
                              ),
                            ]
                          ),
                          _c("v-spacer"),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.list.length > 0
                ? _c("DynamicList", {
                    staticClass: "px-8 py-2",
                    attrs: {
                      searchTerm: _vm.searchTerm,
                      pageSize: _vm.pageSize,
                      styles: _vm.styles,
                      data: _vm.list,
                      headers: _vm.headers,
                      columnSelection: _vm.columnSelection,
                    },
                  })
                : _vm._e(),
              _c(
                "v-row",
                {
                  staticClass: "wrapper mt-5",
                  staticStyle: { position: "fixed" },
                  style: { top: _vm.position.top, left: _vm.position.left },
                  attrs: { cols: "2" },
                },
                [
                  _vm.selectionIsOpen
                    ? _c(
                        "v-card",
                        {
                          staticClass: "mr-10 pa-5",
                          attrs: {
                            color: _vm.$vuetify.theme.dark
                              ? "#1E1E1E"
                              : "grey lighten-2",
                            width: "unset",
                          },
                        },
                        [
                          _c("ColumnControl", {
                            directives: [
                              {
                                name: "click-outside",
                                rawName: "v-click-outside",
                                value: _vm.handleOutsideClick,
                                expression: "handleOutsideClick",
                              },
                            ],
                            attrs: {
                              id: "column-control",
                              headers: _vm.headers,
                              columnSelection: _vm.columnSelection,
                            },
                            on: { update: _vm.updateSelectedColumns },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }